import React from 'react';
import PropTypes from 'prop-types';
import ChatRoom from 'components/ChatRoom';
import { ChatWrapper } from './styles';

function Chat(props) {
  const { match: { params: { id } } } = props;

  const chatId = parseInt(id, 10);

  return (
    <ChatWrapper>
      <ChatRoom chatId={chatId} />
    </ChatWrapper>
  );
}

Chat.propTypes = {
  match: PropTypes.object.isRequired,
};

export default Chat;



// WEBPACK FOOTER //
// ./src/routes/Chat/components/index.jsx